<template>
  <div
    class="toggle"
    :class="{ 'toggle--active': toggled }"
    @click.self="switchToggle"
  >
    <button
      type="button"
      class="toggle__button"
      :class="{ 'toggle__button--active': toggled }"
      @click="switchToggle"
    ></button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ToggleButton",

  props: {
    activeStatus: { type: Boolean },
    disabled: { type: Boolean, default: false },
    // `value`/`reset` drive the toggle from the parent (API client live mode).
    // `null` means "not supplied", which leaves the 2FA source of truth in charge.
    value: { type: Boolean, default: null },
    reset: { type: Boolean, default: false },
  },

  data() {
    return {
      toggled: false,
    };
  },

  computed: {
    ...mapState({
      organisationDetails: (state) => state.organisationModule.organisationDetails,
      teamMember: (state) => state.organisationModule.teamMember,
    }),
    isControlled() {
      return this.value !== null;
    },
  },

  emits: ["value-selected"],

  mounted() {
    if (this.isControlled) {
      this.toggled = this.value;
    } else if (this.activeStatus) {
      this.setToggleFromSource();
    }
  },

  watch: {
    toggled(val) {
      this.$emit("value-selected", val);
    },
    activeStatus() {
      if (!this.isControlled) this.setToggleFromSource();
    },
    teamMember: {
      handler() {
        if (!this.isControlled) this.setToggleFromSource();
      },
      deep: true,
    },
    value(val) {
      if (val !== null) this.toggled = val;
    },
    reset(val) {
      if (val && this.isControlled) this.toggled = this.value;
    },
  },

  methods: {
    switchToggle() {
      if (this.disabled) return;
      this.toggled = !this.toggled;
    },

    setToggleFromSource() {
      if (this.teamMember?.hasOwnProperty("two_factor_enabled")) {
        this.toggled = this.teamMember.two_factor_enabled;
      } else if (this.organisationDetails?.two_factor_enabled !== undefined) {
        this.toggled = this.organisationDetails.two_factor_enabled;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle {
  width: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  height: 25px;
  background: #716e89;
  padding-left: 2px;
  padding-right: 2px;
  transition: all 200ms ease-in-out;
  cursor: pointer;

  &--active {
    background: #4d84ff;
  }

  &__button {
    border-radius: 50%;
    border: 0;
    width: 20px;
    height: 20px;
    background: #fff;
    padding: 0;
    margin-bottom: 1px;
    transform: translateY(0.5px);
    transition: transform 300ms ease-in-out;

    &--active {
      transform: translateX(15px);
    }
  }
}
</style>
